import type { FaireProductEntity } from "../../entity_types/product";

export const p_5frju2xq7m: FaireProductEntity = {
  token: "p_5frju2xq7m",
  type: "product",
  name: "Cat's Meow Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2d4806bcd3b82680c3bfdfd849d0c970eeb5ac9bc1621b049ac8d6c01fa5cef9.webp",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:29.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
